import { EExamTypes, UnsubscribableEmailType, EOposNumberOfExams } from '@constants';

export const StudentProfileConfigurationTranslations = {
  PROFILE: {
    es: 'Mi perfil',
    en: 'My profile',
    cat: 'El meu perfil',
    eus: 'Nire profila',
    pt: 'O meu perfil'
  },
  EDIT_PROFILE: {
    es: 'Editar perfil',
    en: 'Edit profile',
    cat: 'Editar perfil',
    eus: 'Editatu profila',
    pt: 'Editar perfil'
  },
  SAVE_CHANGES: {
    es: 'Guardar cambios',
    en: 'Save changes',
    cat: 'Guardar canvis',
    eus: 'Aldatuak gorde',
    pt: 'Guardar alterações'
  },
  SUCCESS_SAVED_CHANGES: {
    es: 'Cambios guardados correctamente',
    en: 'Changes saved successfully',
    cat: 'Canvis guardats correctament',
    eus: 'Aldatuak ongi gorde dira',
    pt: 'Alterações salvas com sucesso'
  },
  TRAINING_INFO: {
    es: 'Datos de la formación',
    en: 'Training data',
    cat: 'Dades de la formació',
    eus: 'Prestakuntzaren datuak',
    pt: 'Dados de formação'
  },
  CERTIFICATES: {
    es: 'Mis certificados',
    en: 'My certificates',
    cat: 'Els meus certificats',
    eus: 'Nire egiaztagiriak',
    pt: 'Os meus certificados'
  },
  EMAIL: {
    es: 'Correo electrónico',
    en: 'Email',
    cat: 'Correu electrònic',
    eus: 'Posta elektronikoa',
    pt: 'Email'
  },
  EMAIL_REQUIRED: {
    es: 'El correo electrónico no puede estar vacío.',
    en: 'Email cannot be empty.',
    cat: 'El correu electrònic no pot estar buit.',
    eus: 'Posta elektronikoa ezin da hutsik egon.',
    pt: 'O email não pode estar vazio.'
  },
  CONTRACT: {
    es: 'Contrato',
    en: 'Contract',
    cat: 'Contracte',
    eus: 'Kontratua',
    pt: 'Contrato'
  },
  VIEW_CONTRACT: {
    es: 'Ver contrato',
    en: 'View contract',
    cat: 'Veure contracte',
    eus: 'Ikusi kontratua',
    pt: 'Ver contrato'
  },
  CLOSE: {
    es: 'Cerrar',
    en: 'Close',
    cat: 'Tancar',
    eus: 'Itxi',
    pt: 'Fechar'
  },
  PROFILE_UPDATED_SUCCESSFULLY: {
    es: '¡Perfil actualizado con éxito!',
    en: 'Profile updated successfully!',
    cat: 'Perfil actualitzat amb èxit!',
    eus: 'Profila ongi eguneratua!',
    pt: 'Perfil atualizado com sucesso!'
  },
  TRAINING_INFO_UPDATED_SUCCESSFULLY: {
    es: '¡Datos de tu formación actualizados con éxito!',
    en: 'Your training data has been successfully updated!',
    cat: 'Dades de la teva formació actualitzades amb èxit!',
    eus: 'Zure prestakuntzaren datuak ongi eguneratu dira!',
    pt: 'Os seus dados de formação foram atualizados com sucesso!'
  },
  LANGUAGE: {
    es: 'Idioma',
    en: 'Language',
    cat: 'Idioma',
    eus: 'Hizkuntza',
    pt: 'Idioma'
  },
  COURSES: {
    es: 'Cursos',
    en: 'Courses',
    cat: 'Cursos',
    eus: 'Ikastaroak',
    pt: 'Cursos'
  },
  COURSES_SELECT: {
    es: 'Elige los cursos que quieras que se vean en la página de inicio',
    en: 'Choose the courses you want to be displayed on the home page',
    cat: 'Tria els cursos que vulguis que es vegin a la pàgina d`inici',
    eus: 'Aukeratu hasiera orrian ikusi nahi dituzun ikastaroak',
    pt: 'Escolha os cursos que deseja que sejam exibidos na página inicial'
  },
  EXAM_GROUPS: {
    es: '¿A qué convocatorias quieres presentarte?',
    en: 'To which exam groups do you want to apply?',
    cat: 'A quina convocatòria vols presentar-te?',
    eus: 'Zein deialditara aurkeztuko zara?',
    pt: 'Em qual convocatória quer se apresentar?'
  },
  EXAM_GROUPS_NOTIFICATIONS: {
    es: 'Recibir avisos sobre convocatorias',
    en: 'Receive notifications about exam groups',
    cat: 'Rebre notificacions sobre convocatòries',
    eus: 'Deialdiei buruzko jakinarazpenak jasotzea',
    pt: 'Receber notificações sobre convocatórias'
  },
  EXAM_GROUPS_FINDER: {
    es: 'Buscador de convocatorias',
    en: 'Exam groups finder',
    cat: 'Cercador de convocatòries',
    eus: 'Deialdien bilatzailea',
    pt: 'Buscador de convocatórias'
  },
  TAG: {
    es: 'Formación',
    en: 'Tag',
    cat: 'Formació',
    eus: 'Formakuntza',
    pt: 'Formação'
  },
  PROVINCE: {
    es: 'Provincia',
    en: 'Province',
    cat: 'Província',
    eus: 'Probintzia',
    pt: 'Província'
  },
  TITLE: {
    es: 'Título',
    en: 'Title',
    cat: 'Títol',
    eus: 'Titulua',
    pt: 'Título'
  },
  TYPE: {
    es: 'Tipo',
    en: 'Type',
    cat: 'Tipus',
    eus: 'Mota',
    pt: 'Tipo'
  },
  PUBLICATION_DATE: {
    es: 'Fecha de publicación',
    en: 'Publication date',
    cat: 'Data de publicació',
    eus: 'Argitaratze data',
    pt: 'Data de publicação'
  },
  STUDENTS: {
    es: 'Alumnos',
    en: 'Students',
    cat: 'Alumnes',
    eus: 'Ikasleak',
    pt: 'Alunos'
  },
  ADD: {
    es: 'Añadir',
    en: 'Add',
    cat: 'Afegir',
    eus: 'Gehitu',
    pt: 'Adicionar'
  },
  EXAM_GROUPS_EMPTY: {
    es: 'Aquí aparecerán las convocatorias a las que te apuntes. Todavía no has añadido ninguna convocatoria',
    en: 'Here you will see the exam groups you sign up for. You have not added any exam group yet',
    cat: 'Aquí apareixeran les convocatòries a les que t`apuntis. Encara no has afegit cap convocatòria',
    eus: 'Hemen agertuko dira deialdira apuntatzen zara. Oraindik ez duzu deialdirik gehitu',
    pt: 'Aqui aparecerão as convocatórias que se inscreveu. Ainda não adicionou nenhuma convocatória'
  },
  LEAVE_EXAM_GROUP: {
    es: 'Abandonar convocatoria',
    en: 'Leave exam group',
    cat: 'Abandonar convocatòria',
    eus: 'Utzi deialdia',
    pt: 'Deixar convocatória'
  },
  ACTIONS: {
    es: 'Acciones',
    en: 'Actions',
    cat: 'Accions',
    eus: 'Ekintzak',
    pt: 'Ações'
  },
  AT_LEAST_ONE_COURSE_MUST_BE_SELECTED: {
    es: 'Debes seleccionar al menos un curso',
    en: 'You must select at least one course',
    cat: 'Has de seleccionar almenys un curs',
    eus: 'Gutxienez ikastaro bat aukeratu behar duzu',
    pt: 'Você deve selecionar pelo menos um curso'
  },
  EXAM_GROUPS_TOTAL_COUNT: {
    es: '{{total}} convocatorias',
    en: '{{total}} exam groups',
    cat: '{{total}} convocatòries',
    eus: '{{total}} convocatorias',
    pt: '{{total}} convocatórias'
  },
  LEAVE_GROUP_CONFIRMATION: {
    es: '¿Estás seguro de que quieres abandonar la convocatoria?',
    en: 'Are you sure you want to leave the exam group?',
    cat: 'Estàs segur que vols abandonar la convocatòria?',
    eus: 'Ziur zaude deialdia utzi nahi duzula?',
    pt: 'Tem certeza que deseja deixar a convocatória?'
  },
  NOTIFICATION_SETTINGS: {
    es: 'Notificaciones',
    en: 'Notifications',
    cat: 'Notificacions',
    eus: 'Jakinarazpenak',
    pt: 'Notificações'
  },
  LATER: {
    es: 'Más adelante',
    en: 'Later',
    cat: 'Més endavant',
    eus: 'Geroago',
    pt: 'Mais tarde'
  },
  EXAM_GROUPS_NOTIFICATIONS_NAME: {
    es: 'Elige sobre qué Comunidades Autónomas quieres ser notificado',
    en: 'Choose which Autonomous Communities you want to be notified about',
    cat: 'Tria sobre quines Comunitats Autònomes vols ser notificat',
    eus: 'Hautatu zein Autonomia Erkidegotan nahi duzun jakinarazpenak jaso',
    pt: 'Escolha quais Comunidades Autónomas deseja ser notificado'
  },
  TOTAL_PROGRESS: {
    es: 'Avance total',
    en: 'Total progress',
    cat: 'Progrés total',
    eus: 'Aurrerapen guztira',
    pt: 'Progresso total'
  },
  AVERAGE_SCORE: {
    es: 'Nota media',
    en: 'Average score',
    cat: 'Nota mitjana',
    eus: 'Batazbesteko nota',
    pt: 'Nota média'
  },
  TOTAL_POINTS: {
    es: 'Puntuación total',
    en: 'Total points',
    cat: 'Puntuació total',
    eus: 'Puntuazio guztira',
    pt: 'Pontuação total'
  },
  BADGES: {
    es: 'Medallas',
    en: 'Badges',
    cat: 'Medalles',
    eus: 'Medalak',
    pt: 'Medalhas'
  },
  DAILY_STREAK: {
    es: 'Racha diaria',
    en: 'Daily streak',
    cat: 'Ratxa diària',
    eus: 'Eguneroko erronka',
    pt: 'Sequência diária'
  },
  DAILY_COMPLETED_TASKS: {
    es: 'Tareas diarias completadas',
    en: 'Daily completed tasks',
    cat: 'Tasques diàries completades',
    eus: 'Eguneroko zereginak osatuak',
    pt: 'Tarefas diárias completadas'
  },
  GAMIFICATION_INFO: {
    es: 'Consigue puntos de conocimiento para tener un extra en el ranking. Para saber cómo conseguir más, puedes preguntar por el chat.',
    en: 'Get knowledge points to have an extra in the ranking. To know how to get more, you can ask for the chat.',
    cat: 'Aconsegueix punts de coneixement per tenir un extra en el ranking. Per saber com conseguir-ne més, pots preguntar pel xat.',
    eus: 'Lortu ezagutza puntuak rankingean gehigarri bat izateko. Gehiago lortzeko, txat bidez galdetu dezakezu.',
    pt: 'Obtenha pontos de conhecimento para ter um extra no ranking. Para saber como obter mais, você pode perguntar pel chat.'
  },
  REFERRAL_PROMO_TITLE: {
    es: 'Gana 600€',
    en: 'Win 600€',
    cat: 'Guanya 600€',
    eus: '600€ irabazi',
    pt: 'Ganhe 600€'
  },
  REFERRAL_PROMO_SUBTITLE: {
    es: 'Invita a 4 amigos',
    en: 'Invite 4 friends',
    cat: 'Convida 4 amics',
    eus: 'Gonbidatu 4 lagun',
    pt: 'Convidar 4 amigos'
  },
  REFERRAL_PROMO_DESCRIPTION: {
    es: 'Gana {{amount}}€ por cada amigo que se venga a Ucademy',
    en: 'Win {{amount}}€ for each friend who comes to Ucademy',
    cat: 'Guanya {{amount}}€ per cada amic que vingui a Ucademy',
    eus: '{{amount}}€ irabazi lagun bakoitzeko Ucademyra etortzen denean',
    pt: 'Ganhe {{amount}}€ por cada amigo que vier para o Ucademy'
  },
  REFERRAL_PROMO_BUTTON: {
    es: 'Invitar a un amigo',
    en: 'Invite a friend',
    cat: 'Convida un amic',
    eus: 'Gonbidatu lagun bat',
    pt: 'Convidar um amigo'
  },
  RANKING: {
    es: 'Ranking',
    en: 'Ranking',
    cat: 'Ranking',
    eus: 'Ranking',
    pt: 'Ranking'
  },
  GO_TO_RANKING: {
    es: 'Ir a los rankings',
    en: 'Go to rankings',
    cat: 'Anar als rankings',
    eus: 'Joan ranking-era',
    pt: 'Ir para os rankings'
  },
  NOT_JOINED_ANY_EXAM_GROUP: {
    es: '¡Ups!, todavía no te has unido a ninguna convocatoria',
    en: 'Oops!, you have not joined any exam group yet',
    cat: "Ups!, encara no t'has unit a cap convocatòria",
    eus: 'Ups!, oraindik ez zara deialdirik batera',
    pt: 'Ups!, ainda não está inscrito em nenhuma convocatória'
  },
  STATE: {
    es: 'Estatal',
    en: 'State',
    cat: 'Estat',
    eus: 'Estatu',
    pt: 'Estado'
  },
  MY_EXAM_GROUPS: {
    es: 'Mis convocatorias',
    en: 'My exam groups',
    cat: 'Les meves convocatòries',
    eus: 'Nire deialdiak',
    pt: 'Minhas convocatórias'
  },
  HOW_DO_EXAM_GROUPS_WORK: {
    es: '¿Cómo funcionan las convocatorias?',
    en: 'How do exam groups work?',
    cat: 'Com funcionen les convocatòries?',
    eus: 'Nola funtzionatzen dute deialdiak?',
    pt: 'Como funcionam as convocatórias?'
  },
  EXAM_GROUPS_EXPLANATION_1: {
    es: 'En Ucademy publicamos todas las convocatorias oficiales del BOE en la plataforma todos los días. Cuando el gobierno autonómico, provincial o estatal pública una convocatoria, no salen siempre todos los datos al principio. Algunos se actualizan más adelante. Cuando el gobierno correspondiente los actualiza, nosotros también.',
    en: 'At Ucademy we publish all the official BOE calls on the platform every day. When the regional, provincial or state government publishes a call, not all the data comes out at the beginning. Some are updated later. When the corresponding government updates them, we do too.',
    cat: 'A Ucademy publiquem totes les convocatòries oficials del BOE a la plataforma cada dia. Quan el govern autonòmic, provincial o estatal publica una convocatòria, no surten sempre totes les dades al principi. Algunes s`actualitzen més endavant. Quan el govern corresponent les actualitza, nosaltres també.',
    eus: 'Ucademyk egunero BOEko deialdi ofizial guztiak argitaratzen ditu plataforma. Autonomia, probintzia edo estatuko gobernuak deialdia argitaratzen duenean, ez dira beti datu guztiak agertzen hasieran. Batzuk geroago eguneratzen dira. Gobernu horrek eguneratzen dituenean, guk ere eguneratzen dugu.',
    pt: 'A Ucademy publicamos todas as convocatórias oficiais do BOE na plataforma todos os dias. Quando o governo autónomo, provincial ou estadual publica uma convocatória, nem sempre todos os dados saem no início. Alguns são atualizados mais tarde. Quando o governo correspondente atualiza, nós também.'
  },
  EXAM_GROUPS_EXPLANATION_2: {
    es: 'Así que no te preocupes si hay algún dato en el que pone "No disponible". Lo actualizaremos en cuanto se publique, y si estás apuntado a la convocatoria, te lo notificaremos.',
    en: "So don't worry if there is any data that says 'Not available'. We will update it as soon as it is published, and if you are signed up for the call, we will notify you.",
    cat: "Així que no et preocupis si hi ha alguna dada que posa 'No disponible'. L'actualitzarem en quant es publiqui, i si estàs apuntat a la convocatòria, t'ho notificarem.",
    eus: 'Beraz, ez kezkatu "Ez dagoela" esaten duen edozein datu. Eguneratuko dugu argitaratzen denean, eta deialdian apuntatuta badagozu, jakinaraziko dizugu.',
    pt: 'Bem, não se preocupe se houver algum dado que diz "Não disponível". Atualizaremos assim que for publicado, e se você está inscrito na convocatória, você será notificado.'
  },
  EXAM_GROUPS_EXPLANATION_3: {
    es: 'Lo mismo con las convocatorias disponibles: Si no la encuentras o ves vacío el listado, es porque no ha salido.',
    en: 'The same with the available calls: If you do not find it or see the list empty, it is because it has not come out.',
    cat: 'El mateix amb les convocatòries disponibles: Si no la trobes o veus buit el llistat, és perquè no ha sortit.',
    eus: 'Berdin deialdiak eskuragarriak direnean: Ez baduzu aurkitzen edo zerrenda hutsa ikusten baduzu, ez da agertu.',
    pt: 'O mesmo com as convocatórias disponíveis: Se não a encontrar ou ver a lista vazia, é porque ainda não saiu.'
  },
  JOINED_ON: {
    es: 'Se unió en {{month}} de {{year}}',
    en: 'Joined on {{month}} of {{year}}',
    cat: 'Es va unir en {{month}} de {{year}}',
    eus: '{{year}}ko {{month}}an batu zen',
    pt: 'Uniu-se em {{month}} de {{year}}'
  },
  IN_WHICH_CA_DO_YOU_APPLY: {
    es: '¿En qué Comunidad Autónoma te presentas?',
    en: 'In which Autonomous Community do you apply?',
    cat: 'A quina Comunitat Autònoma et presentes?',
    eus: 'Zein Autonomia Erkidegotan aurkeztuko zara?',
    pt: 'Em qual Comunidade Autónoma se apresenta?'
  },
  WHAT_FIELD_DO_YOU_WANT_TO_STUDY: {
    es: '¿Qué rama quieres estudiar?',
    en: 'Which field do you want to study?',
    cat: 'Quina branca vols estudiar?',
    eus: 'Zein arlotan ikasi nahi duzu?',
    pt: 'Em qual área quer estudar?'
  },
  WHAT_CAREER_DO_YOU_WANT_TO_STUDY: {
    es: '¿Qué carrera te gustaría estudiar?',
    en: 'Which career would you like to study?',
    cat: 'Quina carrera t`agradaria estudiar?',
    eus: 'Zein karrera ikasi nahi duzu?',
    pt: 'Em qual carreira quer estudar?'
  },
  WHAT_SUBJECTS_DO_YOU_WANT_TO_STUDY: {
    es: '¿Qué asignaturas vas a estudiar?',
    en: 'Which subjects are you going to study?',
    cat: 'Quines assignatures estudiaràs?',
    eus: 'Zein ikasgai ikasiko dituzu?',
    pt: 'Em qual disciplina quer estudar?'
  },
  WHEN_ARE_YOU_GOING_TO_APPLY: {
    es: '¿Cuándo te vas a presentar?',
    en: 'When are you going to apply?',
    cat: 'Quan et presentaràs?',
    eus: 'Noiz aurkeztuko zara?',
    pt: 'Quando vai se apresentar?'
  },
  WHAT_IS_YOUR_BIRTH_COUNTRY: {
    es: '¿Cuál es tu país de nacimiento?',
    en: 'What is your country of birth?',
    cat: 'Quin és el teu país de naixement?',
    eus: 'Zein da zure jaiotze-herria?',
    pt: 'Qual é o seu país de nascimento?'
  },
  WHAT_IS_YOUR_AGE: {
    es: '¿Cuántos años tienes?',
    en: 'How old are you?',
    cat: 'Quants anys tens?',
    eus: 'Zenbat urte dituzu?',
    pt: 'Quantos anos tem?'
  },
  I_DONT_KNOW_YET: {
    es: 'Aún no lo sé',
    en: "I don't know yet",
    cat: 'Encara no ho sé',
    eus: 'Oraindik ez dakit',
    pt: 'Ainda não sei'
  },
  HAVE_YOU_TAKEN_AN_OPPOSITION: {
    es: '¿Te has presentado alguna vez a una oposición?',
    en: 'Have you ever taken an opposition?',
    cat: 'T`has presentat alguna vegada a una oposició?',
    eus: 'Egin duzu inoiz oposizio bat?',
    pt: 'Já participou em uma oposição?'
  },
  WHEN_DID_YOU_TAKE_IT: {
    es: '¿Cuándo te presentaste?',
    en: 'When did you take it?',
    cat: 'Quan et vas presentar?',
    eus: 'Noiz aurkeztu zinen?',
    pt: 'Quando participou?'
  },
  WHAT_OPPOSITION_DID_YOU_TAKE: {
    es: '¿A qué oposición?',
    en: 'What opposition did you take?',
    cat: 'A quina oposició?',
    eus: 'Zein oposizio?',
    pt: 'Qual oposição?'
  },
  WHAT_STUDIES_DO_YOU_HAVE: {
    es: '¿Qué estudios tienes?',
    en: 'What studies do you have?',
    cat: 'Quins estudis tens?',
    eus: 'Zeintzuk dituzu ikasketak?',
    pt: 'Quais estudos tem?'
  },
  WHAT_IS_YOUR_OCCUPATION: {
    es: '¿Cuál es tu profesión?',
    en: 'What is your occupation?',
    cat: 'Quina és la teva professió?',
    eus: 'Zein da zure profesioa?',
    pt: 'Qual é a sua profissão?'
  },
  ARE_YOU_CURRENTLY_WORKING: {
    es: '¿Estás trabajando actualmente?',
    en: 'Are you currently working?',
    cat: 'Estàs treballant actualment?',
    eus: 'Lan egiten ari zara orain?',
    pt: 'Está trabalhando atualmente?'
  },
  WHAT_IS_YOUR_CURRENT_OCCUPATION: {
    es: '¿Cuál es tu profesión actual?',
    en: 'What is your current occupation?',
    cat: 'Quina és la teva professió actual?',
    eus: 'Zein da zure uneko profesioa?',
    pt: 'Qual é a sua profissão atual?'
  },
  IN_WHICH_CA_DO_YOU_LIVE: {
    es: '¿En qué Comunidad Autónoma vives?',
    en: 'In which Autonomous Community do you live?',
    cat: 'A quina Comunitat Autònoma vius?',
    eus: 'Zein Autonomia Erkidegotan bizi zara?',
    pt: 'Em qual Comunidade Autónoma vive?'
  },
  WHEN_DO_YOU_PREFER_LIVE_CLASSES: {
    es: '¿Cuándo prefieres que sean las clases en directo?',
    en: 'When do you prefer live classes?',
    cat: 'Quan prefereixes que siguin les classes en directe?',
    eus: 'Noiz nahi duzu direla klaseak zuzenean?',
    pt: 'Quando prefere as aulas ao vivo?'
  },
  CERTIFIED_GRADES_CERTIFICATE_OR_TITLE: {
    es: 'Certificado de notas o título compulsado',
    en: 'Certified grades certificate or title',
    cat: 'Certificat de notes o títol compulsat',
    eus: 'Nota egiaztatua edo titulua',
    pt: 'Certificado de notas ou título compulsado'
  },
  WE_NEED_IT_FOR_THE_CAM: {
    es: 'Lo necesitamos para la CAM (administración pública)',
    en: 'We need it for the CAM (public administration)',
    cat: 'Ho necessitem per la CAM (administració pública)',
    eus: 'Behar dugu CAM (administrazio publikoa)',
    pt: 'Precisamos disso para a CAM (administração pública)'
  },
  WE_NEED_IT_FOR_THE_CAM_IN_PDF_FORMAT: {
    es: 'Lo necesitamos para la CAM (administración pública) y en formato PDF.',
    en: 'We need it for the CAM (public administration) and in PDF format.',
    cat: 'Ho necessitem per la CAM (administració pública) i en format PDF.',
    eus: 'Behar dugu CAM (administrazio publikoa) eta PDF formatuan.',
    pt: 'Precisamos disso para a CAM (administração pública) e no formato PDF.'
  },
  DO_YOU_NEED_STUDENT_VISA: {
    es: '¿Necesitas visado de estudiante?',
    en: 'Do you need a student visa?',
    cat: 'Necessites visat d`estudiant?',
    eus: 'Behar duzu ikasle biza?',
    pt: 'Precisa de visto de estudante?'
  },
  ATTACH_THE_HOMOLOGATION_REQUEST: {
    es: 'Adjunta la solicitud de homologación',
    en: 'Attach the homologation request',
    cat: 'Adjunta la sol·licitud d`homologació',
    eus: 'Erantsi omologazio eskaera',
    pt: 'Anexar a solicitação de homologação'
  },
  ENROLLMENT: {
    es: 'Matrícula',
    en: 'Enrollment',
    cat: 'Matrícula',
    eus: 'Matrikula',
    pt: 'Matrícula'
  },
  NAME: {
    es: 'Nombre',
    en: 'Name',
    cat: 'Nom',
    eus: 'Izena',
    pt: 'Nome'
  },
  SURNAME: {
    es: 'Primer apellido',
    en: 'First surname',
    cat: 'Primer cognom',
    eus: 'Lehen abizena',
    pt: 'Primeiro apelido'
  },
  SECOND_SURNAME: {
    es: 'Segundo apellido',
    en: 'Second surname',
    cat: 'Segon cognom',
    eus: 'Bigarren abizena',
    pt: 'Segundo apelido'
  },
  PHONE: {
    es: 'Teléfono',
    en: 'Phone',
    cat: 'Telèfon',
    eus: 'Telefonoa',
    pt: 'Telefone'
  },
  DNI_NIE_PASSPORT: {
    es: 'DNI/NIE/Pasaporte',
    en: 'DNI/NIE/Passport',
    cat: 'DNI/NIE/Passaport',
    eus: 'DNI/NIE/Pasaportea',
    pt: 'DNI/NIE/Passaporte'
  },
  BIRTH_DATE: {
    es: 'Fecha de nacimiento',
    en: 'Birth date',
    cat: 'Data de naixement',
    eus: 'Jaiotze data',
    pt: 'Data de nascimento'
  },
  COUNTRY_BIRTH: {
    es: 'País de nacimiento',
    en: 'Country of birth',
    cat: 'País de naixement',
    eus: 'Jaioterria',
    pt: 'País de nascimento'
  },
  COUNTRY_RESIDENCE: {
    es: 'País de residencia',
    en: 'Country of residence',
    cat: 'País de residència',
    eus: 'Bizilekua',
    pt: 'País de residência'
  },
  CURRENTLY_WORKING: {
    es: '¿Estás trabajando actualmente?',
    en: 'Are you currently working?',
    cat: 'Estàs treballant actualment?',
    eus: 'Lan egiten ari zara orain?',
    pt: 'Está trabalhando atualmente?'
  },
  YES: {
    es: 'Sí',
    en: 'Yes',
    cat: 'Sí',
    eus: 'Bai',
    pt: 'Sim'
  },
  NO: {
    es: 'No',
    en: 'No',
    cat: 'No',
    eus: 'Ez',
    pt: 'Não'
  },
  CURRENTLY_WORKING_AT: {
    es: '¿En qué trabajas?',
    en: 'Where do you work?',
    cat: 'On treballes?',
    eus: 'Non egiten duzu lan?',
    pt: 'Onde trabalha?'
  },
  SALARY_RANGE: {
    es: '¿Cuál es tu rango salarial?',
    en: 'What is your salary range?',
    cat: 'Quin és el teu rang salarial?',
    eus: 'Zein da zure soldata-tartea?',
    pt: 'Qual é a sua faixa salarial?'
  },
  SOCIAL_SECURITY_NUMBER: {
    es: 'Número de la Seguridad Social',
    en: 'Social Security Number',
    cat: 'Número de la Seguretat Social',
    eus: 'Gizarte Segurantzaren zenbakia',
    pt: 'Número da Segurança Social'
  },
  SOCIAL_SECURITY_NUMBER_MUST_HAVE_12_DIGITS: {
    es: 'El número de la seguridad social debe tener 12 dígitos numéricos.',
    en: 'The social security number must have 12 numeric digits.',
    cat: 'El número de la seguretat social ha de tenir 12 dígits numèrics.',
    eus: 'Gizarte Segurantzako zenbakiak 12 digitu zenbakizko izan behar ditu.',
    pt: 'O número da segurança social deve ter 12 dígitos numéricos.'
  },
  YOUR_SOCIAL_SECURITY_NUMBER: {
    es: 'Tu número de la Seguridad Social',
    en: 'Your Social Security Number',
    cat: 'El teu número de la Seguretat Social',
    eus: 'Zure Gizarte Segurantzaren zenbakia',
    pt: 'O seu número da Segurança Social'
  },
  PORTRAIT_PHOTO: {
    es: 'Foto de carnet',
    en: 'Portrait photo',
    cat: 'Foto de carnet',
    eus: 'Argazki erretratu',
    pt: 'Fotografia de porte'
  },
  FRONT_AND_BACK_SIDES: {
    es: 'Parte delantera y trasera',
    en: 'Front and back sides',
    cat: 'Part frontal i posterior',
    eus: 'Aurrealdea eta atzealdea',
    pt: 'Parte frontal e posterior'
  },
  GENDER: {
    es: 'Género',
    en: 'Gender',
    cat: 'Gènere',
    eus: 'Generoa',
    pt: 'Gênero'
  },
  FRONTAL_BUST_PHOTO: {
    es: 'Foto del busto de frente, como la que figura en tu DNI o NIE.',
    en: 'Frontal bust photo, like the one on your ID.',
    cat: 'Foto del bust de front, com la que figura al teu DNI o NIE.',
    eus: 'Aurrealdeko busto argazkia, zure DNI edo NIEan agertzen den bezala.',
    pt: 'Fotografia de busto frontal, como a que está no seu DNI ou NIE.'
  },
  CITY: {
    es: 'Ciudad',
    en: 'City',
    cat: 'Ciutat',
    eus: 'Hiria',
    pt: 'Cidade'
  },

  GENERAL_INFORMATION: {
    es: 'Información general',
    en: 'General information',
    cat: 'Informació general',
    eus: 'Informazio orokorra',
    pt: 'Informação geral'
  },

  BIRTH_DATA: {
    es: 'Datos de nacimiento',
    en: 'Birth data',
    cat: 'Dades de naixement',
    eus: 'Jaiotza-datuak',
    pt: 'Dados de nascimento'
  },

  IDENTIFICATION_DOCUMENT: {
    es: 'Documento de identificación',
    en: 'Identification document',
    cat: "Document d'identificació",
    eus: 'Identifikazio dokumentua',
    pt: 'Documento de identificação'
  },

  NATIONALITY: {
    es: 'Nacionalidad',
    en: 'Nationality',
    cat: 'Nacionalitat',
    eus: 'Nazionalitatea',
    pt: 'Nacionalidade'
  },
  BIRTH_PROVINCE: {
    es: 'Provincia de nacimiento',
    en: 'Birth province',
    cat: 'Província de naixement',
    eus: 'Jaiotze-probintzia',
    pt: 'Província de nascimento'
  },
  BIRTH_MUNICIPALITY: {
    es: 'Municipio de nacimiento',
    en: 'Birth municipality',
    cat: 'Municipi de naixement',
    eus: 'Jaiotze-udalerria',
    pt: 'Município de nascimento'
  },
  BIRTH_LOCALITY: {
    es: 'Localidad de nacimiento',
    en: 'Birth locality',
    cat: 'Localitat de naixement',
    eus: 'Jaiotze-herria',
    pt: 'Localidade de nascimento'
  },
  FOREIGN_BIRTH_LOCALITY: {
    es: 'Localidad de nacimiento extranjera',
    en: 'Foreign birth locality',
    cat: 'Localitat de naixement estrangera',
    eus: 'Jaiotze-herria etarra',
    pt: 'Localidade de nascimento estrangeira'
  },
  MUNICIPALITY: {
    es: 'Municipio',
    en: 'Municipality',
    cat: 'Municipi',
    eus: 'Udalerria',
    pt: 'Município'
  },
  RESIDENCE_LOCALITY: {
    es: 'Localidad de residencia',
    en: 'Residence locality',
    cat: 'Localitat de residència',
    eus: 'Bizileku-herria',
    pt: 'Localidade de residência'
  },
  STREET_TYPE: {
    es: 'Tipo de vía',
    en: 'Street type',
    cat: 'Tipus de via',
    eus: 'Bide mota',
    pt: 'Tipo de via'
  },
  ADDRESS_DATA: {
    es: 'Datos de domicilio',
    en: 'Address data',
    cat: 'Dades de domicili',
    eus: 'Etxebizitza-datuak',
    pt: 'Dados de domicílio'
  },
  STREET_NAME: {
    es: 'Nombre de la vía',
    en: 'Street name',
    cat: 'Nom de la via',
    eus: 'Bidearen izena',
    pt: 'Nome da via'
  },
  STREET_NUMBER: {
    es: 'Número',
    en: 'Number',
    cat: 'Número',
    eus: 'Zenbakia',
    pt: 'Número'
  },
  FLOOR: {
    es: 'Piso',
    en: 'Floor',
    cat: 'Pis',
    eus: 'Pisua',
    pt: 'Andar'
  },
  STAIRCASE: {
    es: 'Escalera',
    en: 'Staircase',
    cat: 'Escala',
    eus: 'Eskailera',
    pt: 'Escada'
  },
  DOOR: {
    es: 'Puerta',
    en: 'Door',
    cat: 'Porta',
    eus: 'Atea',
    pt: 'Porta'
  },
  POSTAL_CODE: {
    es: 'Código postal',
    en: 'Postal code',
    cat: 'Codi postal',
    eus: 'Posta-kodea',
    pt: 'Código postal'
  },
  RESIDENCE_PHONE: {
    es: 'Teléfono fijo',
    en: 'Landline',
    cat: 'Telèfon fix',
    eus: 'Telefono finkoa',
    pt: 'Telefone fixo'
  },

  YOUR_DATA_IS_DISABLED: {
    es: 'Algunos campos no se pueden editar desde aquí. Si necesitas modificarlos, contacta con el equipo académico.',
    en: 'Some fields cannot be edited from here. If you need to modify them, contact the academic team.',
    cat: "Alguns camps no es poden editar des d'aquí. Si necessiteu-los modificar, contacteu amb l'equip acadèmic.",
    eus: 'Batzuk ezin dira editatu hemen. Baldin behar duzu aldatu, egin kontaktua ikasle-taldearekin.',
    pt: 'Alguns campos não podem ser editados a partir aqui. Se precisar modificar, entre em contato com a equipe acadêmica.'
  },

  WHICH_CITY_WOULD_YOU_LIKE_TO_STUDY: {
    es: '¿En qué ciudad te gustaría estudiar?',
    en: 'Which city would you like to study in?',
    cat: 'En quina ciutat vols estudiar?',
    eus: 'Zein hiria nahi duzu ikasten?',
    pt: 'Em qual cidade deseja estudar?'
  },
  EXAMS_SCORES: {
    es: 'Notas de exámenes',
    en: 'Exam scores',
    cat: "Notes d'exàmens",
    eus: 'Ikasle-notak',
    pt: 'Notas de exames'
  },
  [EExamTypes.ONSITE]: {
    es: 'Exámenes presenciales',
    en: 'Onsite exams',
    cat: 'Exàmens presencials',
    eus: 'Presencialen examenak',
    pt: 'Exames presenciais'
  },
  [EExamTypes.DELIVERABLE]: {
    es: 'Documentos entregables',
    en: 'Deliverable documents',
    cat: 'Documents entregables',
    eus: 'Entregatutako dokumentuak',
    pt: 'Documentos entregáveis'
  },
  [EExamTypes.ONLINE]: {
    es: 'Exámenes online',
    en: 'Online exams',
    cat: 'Exàmens online',
    eus: 'Onlineen examenak',
    pt: 'Exames online'
  },
  MY_EXAMS_SCORES: {
    es: 'Mis notas de exámenes',
    en: 'My exam scores',
    cat: "Les meves notes d'exàmens",
    eus: 'Nire ikasle-notak',
    pt: 'Minhas notas de exames'
  },
  MY_EXAMS_SCORES_DESCRIPTION: {
    es: 'Exámenes y archivos online y presenciales puntuados.',
    en: 'Online and onsite exams and documents scored.',
    cat: 'Exàmens i documents online i presencials qualificats.',
    eus: 'Onlineen eta presencialen examenak eta dokumentuak kalifikatuta.',
    pt: 'Exames online e presenciais e documentos qualificados.'
  },
  PLANIFICATION: {
    es: 'Plan de estudio',
    en: 'Study plan',
    cat: 'Pla de treball',
    eus: 'Ikasketa plan',
    pt: 'Plano de estudo'
  },
  REPLANIFY: {
    es: 'Replanificar',
    en: 'Replanify',
    cat: 'Replanificar',
    eus: 'Berreplanifikatu',
    pt: 'Replanificar'
  },
  ARE_YOU_SURE_TO_REPLANIFY: {
    es: '¿Estás seguro de querer replanificar?',
    en: 'Are you sure you want to replanify?',
    cat: 'Estàs segur que vols replanificar?',
    eus: 'Ziur zaude replanifikatu nahi duzula?',
    pt: 'Tem certeza que deseja replanificar?'
  },
  PLANIFICATION_RESULT_END_DATE: {
    es: 'Día de finalización del estudio según tu planificación:',
    en: 'Study end date according to your plan:',
    cat: "Data finalització de l'estudi segons el teu pla:",
    eus: 'Ikasketa bukaeraren data zure planifikazioaren arabera:',
    pt: 'Data de finalização do estudo de acordo com o seu plano:'
  },
  PLANIFICATION_RESULT_DAILY_TIME: {
    es: 'Estudio recomendado al día',
    en: 'Recommended study time per day',
    cat: "Temps d'estudi recomanat al dia",
    eus: 'Ikasketa-denbora egunekoa',
    pt: 'Tempo de estudo recomendado por dia'
  },
  // PLANIFICATION_REST_DAYS_TITLE: {
  //   es: 'Días que no vas a estudiar',
  //   en: 'Days you will not study',
  //   cat: 'Günler, en que no et vas a estudiar',
  //   eus: 'Ikasketa ez egiteko egunak',
  //   pt: 'Dias que não vai estudar'
  // },
  PLANIFICATION_SUBSCRIPTIONS_TITLE: {
    es: 'Contenido planificado',
    en: 'Planned content',
    cat: 'Contingut planificat',
    eus: 'Antolatutako edukia',
    pt: 'Conteúdo planejado'
  },
  PLANIFICATION_DATES_TITLE: {
    es: 'Planificar según...',
    en: 'Planify according to...',
    cat: 'Planificar segons...',
    eus: 'Planifikatu zehaztutako arabera...',
    pt: 'Planificar de acordo com...'
  },
  PLANIFICATION_DATES_STUDY_HOURS: {
    es: 'Horas de estudio al día',
    en: 'Study hours per day',
    cat: 'Estudi al dia',
    eus: 'Ikasketa-denbora egunekoa',
    pt: 'Tempo de estudo por dia'
  },
  PLANIFICATION_DATES_END_DATE: {
    es: 'Fecha de finalización deseada',
    en: 'Desired study end date',
    cat: "Data final desitjada d'estudi",
    eus: 'Ikasketa bukaeraren data zehaztutakoa',
    pt: 'Data de finalização desejada do estudo'
  },
  // PLANIFICATION_DEACTIVATE_TITLE: {
  //   es: 'Desactivar planificación del estudio',
  //   en: 'Deactivate study plan',
  //   cat: 'Desactivar pla de treball',
  //   eus: 'Ikasketa planifikazioa desaktibatu',
  //   pt: 'Desativar o plano de estudo'
  // },
  // PLANIFICATION_DEACTIVATE_SUBTITLE: {
  //   es: 'Dejarás de ver las tareas diarias recomendadas y tu planificación del contenido en el calendario',
  //   en: 'You will no longer see the daily recommended tasks and your planification content in the calendar',
  //   cat: 'No veurem les tasques diàries recomanades i el teu pla de treball en el calendari',
  //   eus: 'Ez duzu eguneko zerbitzuak aurreikusitakoak eta zure planifikazioaren edukia kalendarioan ikusi',
  //   pt: 'Não verá as tarefas recomendadas diariamente e o conteúdo do seu plano de estudo no calendário'
  // },
  PLANIFICATION_DEACTIVATE_SWITCH_LABEL_ACTIVE: {
    es: 'Activado',
    en: 'Active',
    cat: 'Actiu',
    eus: 'Aktibatua',
    pt: 'Ativa'
  },
  PLANIFICATION_DEACTIVATE_SWITCH_LABEL_INACTIVE: {
    es: 'Desactivado',
    en: 'Inactive',
    cat: 'Desactivat',
    eus: 'Desaktibatua',
    pt: 'Inativa'
  },
  PLANIFICATION_HOW_IT_WORKS: {
    es: '¿Cómo funciona la planificación?',
    en: 'How does the plan work?',
    cat: 'Com funciona el pla?',
    eus: 'Nola funtzionatzen du planifikazioa?',
    pt: 'Como funciona o plano?'
  },
  PERSONAL_DATA: {
    es: 'Datos personales',
    en: 'Personal data',
    cat: 'Dades personals',
    eus: 'Pertsonal datuak',
    pt: 'Dados pessoais'
  },
  DO_YOU_HAVE_TEACHING_MASTER: {
    es: '¿Tienes un máster de profesorado?',
    en: 'Do you have a teaching master?',
    cat: 'Tens el Màster en Professorat?',
    eus: 'Irakasletzako masterra duzu?',
    pt: 'Tem um mestrado de ensino?'
  },
  DNI_FILE: {
    es: 'Documento de Identificación',
    en: 'Identification document',
    cat: "Document d'identificació",
    eus: 'Identifikazio dokumentua',
    pt: 'Documento de identificação'
  },
  DNI_FILE_DESC: {
    es: 'Sube una imagen del frente y del dorso del documento. En formato PDF.',
    en: 'Upload a front and back image of the document. PDF format.',
    cat: 'Puja una imatge del davant i del darrere del document. En format PDF.',
    eus: 'Igo dokumentuaren aurreko eta atzeko irudia. PDF formatuan.',
    pt: 'Carregue uma imagem da frente e do verso do documento. Em PDF.'
  },
  SOCIAL_SECURITY_FILE: {
    es: 'Comprobante de Afiliación a la Seguridad Social',
    en: 'Copy of Social Security',
    cat: 'Fotocòpia de la Seguretat Social',
    eus: 'Gizarte Segurantzaren kopia',
    pt: 'Cópia da Segurança Social'
  },
  SOCIAL_SECURITY_FILE_DESC: {
    es: 'Durante tu fase de formación en empresa (prácticas profesionales en empresas reales), estarás dado de alta en la Seguridad Social. Por eso, necesitamos que nos facilites este dato antes de comenzar.',
    en: 'During your company training phase (professional practices in real companies), you will be registered in the Social Security. That is why, we need you to provide this data before starting.',
    cat: 'Durant la fase de formació en empresa (pràctiques professionals en empreses reals), se us registrarà en la Seguretat Social. Per això, necessitem que ens facilitis aquestes dades abans de començar.',
    eus: 'Enpresako prestakuntza fasetik salbuetsita bazaude, igo dokumentu justifikagarria. PDF formatuan.',
    pt: 'Em caso de ter isenção da fase de formação na empresa, carregue o documento comprovativo. Em PDF.'
  },
  SOCIAL_SECURITY_FILE_DO_NOT_ACCEPT: {
    es: 'No se acepta la tarjeta sanitaria como documento válido.',
    en: 'The health card is not accepted as a valid document.',
    cat: 'La tarjeta sanitària no és acceptada com a document vàlid.',
    eus: 'Zure osasun karta ez da onartzen dokumentu baliogabea bezala.',
    pt: 'A carta de saúde não é aceita como documento válido.'
  },
  DEGREE_FILE: {
    es: 'Requisito Legal de Acceso',
    en: 'Legal Access Requirement',
    cat: "Requisit legal d'accés",
    eus: 'Sarrera-eskaera legala',
    pt: 'Requisito legal de acesso'
  },
  DEGREE_FILE_TOOLTIP: {
    es: 'El requisito legal de acceso puede ser el documento acreditativo del título académico de estudios o de la superación de prueba que te da acceso para estudiar esta titulación.',
    en: 'The legal access requirement can be the supporting document for the academic degree or the passing of a test that gives you access to study this degree.',
    cat: "El requisit legal d'accés pot ser el document acreditatiu del títol acadèmic d'estudis o de la superació de prova que et dóna accés per estudiar aquesta titulació.",
    eus: 'Sarrera-eskaera legala ikasketa-titulu akademikoaren edo titulazio hau ikasteko sarbidea ematen dizun probaren gainditzea egiaztatzen duen dokumentua izan daiteke.',
    pt: 'O requisito legal de acesso pode ser o documento comprovativo do título académico de estudos ou da aprovação em teste que lhe dá acesso para estudar esta titulação.'
  },
  DEGREE_FILE_BANNER: {
    es: 'Si has realizado estudios extranjeros no universitarios, tendrás que pedir la homologación o convalidación de tus estudios y subir la credencial condicional de acceso. Cuando tengas la resolución, deberás entregar el documento definitivo de homologación antes de los exámenes finales del curso.',
    en: 'If you have studied abroad, you must upload the homologation or the homologation request in process if you still do not have the definitive one. When you have the resolution, you must deliver the definitive homologation document before the final exams of the course.',
    cat: "Si has estudiat a l'estranger, has d'enviar la homologació o la sol·licitud de homologació en tràmit si encara no tens la definitiva. Quan tinguis la resolució, has d'entregar el document definitiu de homologació abans dels exàmens finals del curs.",
    eus: 'Erdiko mailako prestatzean, homologazio-eskaera ekoitzeko. Homologazioaren dokumentua ekoitzeko, ziurrenik ez duzu egin dagoeneko. Ikastarako maila ekoitzeko, ESO maila, sarrera-probak edo maila baliokidea ekoitzeko.',
    pt: 'Se estudou no exterior, deve carregar a homologação ou a solicitação de homologação em tramitação se ainda não tiver a definitiva. Quando tiver a resolução, deve entregar o documento definitivo de homologação antes dos exames finais do curso.'
  },
  DEGREE_FILE_DESC_1: {
    es: 'Para estudiar un ciclo formativo de grado medio:',
    en: 'To study a medium cycle:',
    cat: 'Per a estudiar un cicle formatiu de grau mitjà:',
    eus: 'Erdiko mailako prestatzean:',
    pt: 'Para estudar um ciclo formativo de grau médio:'
  },
  DEGREE_FILE_REQUIREMENTS_1: {
    es: 'Será necesario como mínimo el título de la Educación Secundaria Obligatoria (ESO), prueba de acceso o cualquier otra titulación oficial de grado académico superior o declarada equivalente.',
    en: 'It is necessary to have at least the title of the Secondary Education (ESO), access test or any other official degree of higher academic grade or declared equivalent.',
    cat: "Es necessari tenir com a mínim el títol de l'Educació Secundària Obligatòria (ESO), prova d'accés o qualsevol altra titulació oficial de grau acadèmic superior o declarada equivalent.",
    eus: 'Ikastarako maila ekoitzeko, ESO maila, sarrera-probak edo maila baliokidea ekoitzeko.',
    pt: 'É necessário ter pelo menos o título de Ensino Secundário (ESO), prova de acesso ou qualquer outra titulação oficial de grau acadêmico superior ou declarada equivalente.'
  },
  DEGREE_FILE_DESC_2: {
    es: 'Para estudiar un ciclo formativo de grado superior:',
    en: 'To study a higher cycle:',
    cat: 'Per a estudiar un cicle formatiu de grau superior:',
    eus: 'Goiko mailako prestatzean:',
    pt: 'Para estudar um ciclo formativo de grau superior:'
  },
  DEGREE_FILE_REQUIREMENTS_2: {
    es: 'Formación Profesional de Grado medio, Bachillerato, prueba de acceso o cualquier otra titulación oficial de grado académico superior o declarada equivalente.',
    en: 'Professional Training of Medium Cycle, Baccalaureate, access test or any other official degree of higher academic grade or declared equivalent.',
    cat: "Formació Professional de Grau mitjà, Batxillerat, prova d'accés o qualsevol altra titulació oficial de grau acadèmic superior o declarada equivalent.",
    eus: 'Erdiko mailako prestatzean, Batxilleratu maila, sarrera-probak edo maila baliokidea ekoitzeko.',
    pt: 'Formação Profissional de Grau médio, Bacharelado, prova de acesso ou qualquer outra titulação oficial de grau acadêmico superior ou declarada equivalente.'
  },
  NOTES_EQUIVALENCE_FILE: {
    es: 'Equivalencia de notas',
    en: 'Grades equivalence',
    cat: 'Equivalència de notes',
    eus: 'Noten baliokidetza',
    pt: 'Equivalência de notas'
  },
  NOTES_EQUIVALENCE_FILE_DESC: {
    es: 'Este documento solo es necesario si tus estudios son extranjeros.',
    en: 'Only if your degree is not Spanish.',
    cat: 'Només si el teu títol no és espanyol.',
    eus: 'Zure titulua espainiarra ez bada bakarrik.',
    pt: 'Apenas se o seu título não for espanhol.'
  },
  STUDY_BRANCH: {
    es: '¿Qué rama quieres estudiar?',
    en: 'Which branch do you want to study?',
    cat: 'Quina branca vols estudiar?',
    eus: 'Zein zirriborro nahi duzu ikasten?',
    pt: 'Qual a sua ramificação de estudo?'
  },
  DEGREE: {
    es: '¿Qué carrera te interesa?',
    en: 'Which degree are you interested in?',
    cat: 'Quina carrera vols estudiar?',
    eus: 'Zein maila nahi duzu ikasten?',
    pt: 'Qual a sua graduação de estudo?'
  },
  UNIVERSITY: {
    es: '¿En qué universidad te gustaría estudiar?',
    en: 'Which university would you like to study at?',
    cat: 'En quina universitat vols estudiar?',
    eus: 'Zein ikastaroa nahi duzu ikasten?',
    pt: 'Em qual universidade deseja estudar?'
  },
  AUTONOMOUS_COMMUNITY: {
    es: '¿A qué Comunidad Autónoma te presentas?',
    en: 'Which Autonomous Community are you applying to?',
    cat: 'A quina Comunitat Autònoma te presents?',
    eus: 'Zein autonomiako komunitatean zara aplikatzen?',
    pt: 'Em qual Comunidade Autónoma se apresenta?'
  },
  AUTONOMOUS_COMMUNITY_WORK: {
    es: '¿En qué Comunidad Autónoma te gustaría trabajar?',
    en: 'In which Autonomous Community would you like to work?',
    cat: "A quina Comunitat Autònoma t'agradaria treballar?",
    eus: 'Zein autonomia-erkidegotan lan egin nahiko zenuke?',
    pt: 'Em qual Comunidade Autónoma gostaria de trabalhar?'
  },
  EXAMS: {
    es: '¿A qué exámenes quieres presentarte?',
    en: 'Which exams do you want to take?',
    cat: 'Quins exàmens vols presentar?',
    eus: 'Zein examenak nahi duzu egin?',
    pt: 'Quais exames deseja apresentar?'
  },
  SUBJECTS_TITLE: {
    es: 'Completa las notas de las asignaturas que estudiaste',
    en: 'Complete the grades of the subjects you studied',
    cat: 'Completa les notes de les assignatures que has estudiat',
    eus: 'Ikasle-notak zure ikasten dituzten gaienak bete',
    pt: 'Complete as notas das disciplinas que estudou'
  },
  SUBJECT: {
    es: 'Asignatura',
    en: 'Subject',
    cat: 'Assignatura',
    eus: 'Gaia',
    pt: 'Disciplina'
  },
  GRADE: {
    es: 'Nota',
    en: 'Grade',
    cat: 'Nota',
    eus: 'Ikasle-nota',
    pt: 'Nota'
  },
  ADD_SUBJECT: {
    es: 'Añadir asignatura',
    en: 'Add subject',
    cat: 'Afegeix assignatura',
    eus: 'Gaia gehitu',
    pt: 'Adicionar disciplina'
  },
  REMOVE_SUBJECT: {
    es: 'Eliminar',
    en: 'Remove',
    cat: 'Elimina',
    eus: 'Ezabatu',
    pt: 'Remover'
  },
  HAS_MASTER_DEGREE: {
    es: '¿Tienes el Máster en Profesorado?',
    en: "Do you have the Master's in Teaching?",
    cat: 'Tens el Màster en Professorat?',
    eus: 'Irakasletzako masterra duzu?',
    pt: 'Tem o Mestrado em Ensino?'
  },
  NEED_VISA: {
    es: '¿Necesitas visado?',
    en: 'Do you need a visa?',
    cat: 'Necessites visat?',
    eus: 'Bisarik behar duzu?',
    pt: 'Precisa de visto?'
  },
  HAS_CERTIFICATE_DEGREE: {
    es: '¿Tienes título homologado?',
    en: 'Do you have a homologated degree?',
    cat: 'Tens títol homologat?',
    eus: 'Homologatutako maila duzu?',
    pt: 'Tem título homologado?'
  },
  HAS_NOTES_EQUIVALENCE: {
    es: '¿Has hecho la equivalencia de notas?',
    en: 'Have you done the grade equivalence?',
    cat: "Has fet l'equivalència de notes?",
    eus: 'Noten baliokidetza egin duzu?',
    pt: 'Fez a equivalência de notas?'
  },
  PLANIFICATION_EMPTY_TITLE: {
    es: '¡Activa tu plan de estudio!',
    en: 'Activate your study plan!',
    cat: "Activa el teu pla d'estudi!",
    eus: 'Aktibatu zure ikasketa-plana!',
    pt: 'Ative o seu plano de estudo!'
  },
  PLANIFICATION_EMPTY_DESCRIPTION: {
    es: 'Organizamos el temario en tareas diarias para que llegues a tu meta sin perderte en el camino.',
    en: 'We organize the syllabus into daily tasks so you reach your goal without getting lost along the way.',
    cat: "Organitzem el temari en tasques diàries perquè arribis al teu objectiu sense perdre't pel camí.",
    eus: 'Gai-zerrenda eguneroko zereginetan antolatzen dugu, zure helburura iritsi zaitezen bidean galdu gabe.',
    pt: 'Organizamos o conteúdo em tarefas diárias para que você atinja seu objetivo sem se perder no caminho.'
  },
  PLANIFICATION_EMPTY_BUTTON: {
    es: 'Planificar mi estudio',
    en: 'Plan my study',
    cat: 'Planifica el meu estudi',
    eus: 'Nire ikasketa planifikatu',
    pt: 'Planear meu estudo'
  },
  END_DATE: {
    es: 'Fecha de fin',
    en: 'End date',
    cat: 'Data final',
    eus: 'Ikasketa bukaeraren data',
    pt: 'Data de finalização'
  },
  PHOTO: {
    es: 'Foto carnet',
    en: 'Photo card',
    cat: 'Foto de carnet',
    eus: 'Karte-irudia',
    pt: 'Foto do cartão'
  },
  PHOTO_DESC: {
    es: 'Sube una foto en tamaño carnet.',
    en: 'Upload a photo in card size.',
    cat: 'Puja una foto en mida de carnet.',
    eus: 'Karte-irudia ekoitzeko irudia',
    pt: 'Carregue uma foto em tamanho de cartão.'
  },
  SUBJECTS_TO_VALIDATE: {
    es: 'Asignaturas a convalidar',
    en: 'Subjects to validate',
    cat: 'Assignatures per convalidar',
    eus: 'Gaiak konvalidatu nahi dituzten gaiak',
    pt: 'Disciplinas para convalidar'
  },
  SUBJECTS_TO_VALIDATE_DESC: {
    es: 'En caso de tener asignaturas para convalidar, sube el archivo que te hemos enviado por correo.',
    en: 'In case you have subjects to validate, upload the file we have sent you by email.',
    cat: "En cas de tenir assignatures per convalidar, puja el fitxer que t'hem enviat per correu.",
    eus: 'Konvalidatu nahi dituzten gaien fitxategia ekoitzeko, igo zure posta elektronikora bidali dizutena.',
    pt: 'Em caso de ter disciplinas para convalidar, carregue o arquivo que recebeu por e-mail.'
  },
  COMPANY_TRAINING_EXEMPTION_FILE: {
    es: 'Exención de Fase de Formación en Empresa',
    en: 'Company Training Phase Exemption',
    cat: 'Exempció de Fase de Formació en Empresa',
    eus: 'Enpresako Prestakuntza Fasearen Salbuespena',
    pt: 'Isenção de Fase de Formação na Empresa'
  },
  COMPANY_TRAINING_EXEMPTION_FILE_DESC: {
    es: 'Deberás entregar la documentación acreditativa que justifique la exención de la Fase de Formación en Empresa o Formación en Centros de Trabajo solicitado.',
    en: 'You must deliver the supporting documentation that justifies the exemption from the Company Training Phase or Work Center Training requested.',
    cat: "Has d'entregar el document justificatiu que justifica l'exempció de la Fase de Formació en Empresa o Formació en Centres de Treball sol·licitat.",
    eus: 'Enpresako prestakuntza fasetik salbuetsita bazaude, igo dokumentu justifikagarria. Eskaera publikoaren onarpena.',
    pt: 'Deve entregar o documento comprovativo que justifica a isenção da Fase de Formação na Empresa ou Formação em Centros de Trabalho solicitada.'
  },
  PERCENTAGE_COMPLETE_PROFILE: {
    es: 'Porcentaje de perfil completo',
    en: 'Complete profile percentage',
    cat: 'Percentatge de perfil complet',
    eus: 'Profil osoaren ehunekoa',
    pt: 'Percentagem de perfil completo'
  },
  STREAK_DAYS: {
    es: '{{days}} días',
    en: '{{days}} days',
    cat: '{{days}} dies',
    eus: '{{days}} egun',
    pt: '{{days}} dias'
  },
  ALLOW_EMAIL_NOTIFICATIONS: {
    es: 'Recibir avisos por correo electrónico',
    en: 'Receive email notifications',
    cat: 'Rebre notificacions per correu electrònic',
    eus: 'Posta elektronikoz jakinarazpenak jasotzea',
    pt: 'Receber notificações por e-mail'
  },
  [UnsubscribableEmailType.NEW_POST]: {
    es: 'Nueva noticia publicada',
    en: 'New post published',
    cat: 'Nou post publicat',
    eus: 'Albiste berria argitaratu da',
    pt: 'Artigo novo publicado'
  },
  [UnsubscribableEmailType.NEW_LIVERECORD]: {
    es: 'Nueva clase grabada disponible',
    en: 'New class recording available',
    cat: 'Nova gravació disponible',
    eus: 'Grabazio berria eskuragarri',
    pt: 'Nova gravação disponível'
  },
  [UnsubscribableEmailType.DELIVERABLE_MESSAGE_CREATED]: {
    es: 'Nuevo mensaje en entregable',
    en: 'New message in deliverable',
    cat: 'Nou missatge en entregable',
    eus: 'Entrega berriaren mezu bat',
    pt: 'Nova mensagem em entregável'
  },
  [UnsubscribableEmailType.TICKET_MESSAGE_CREATED]: {
    es: 'Nuevo mensaje de respuesta en duda',
    en: 'New message of answer in ticket',
    cat: 'Nou missatge de resposta en dubte',
    eus: 'Berria zalantzaren erantzunaren mezu bat',
    pt: 'Nova mensagem de resposta em dúvida'
  },
  [UnsubscribableEmailType.PROBLEM_REPORT_CREATED]: {
    es: 'Reporte de contenido recibido',
    en: 'Content report received',
    cat: 'Reporte de contingut creat',
    eus: 'Edukiaren ziurtagiria jaso da',
    pt: 'Relatório de conteúdo recebido'
  },
  [UnsubscribableEmailType.PROBLEM_REPORT_SOLVED]: {
    es: 'Reporte de contenido resuelto',
    en: 'Content report resolved',
    cat: 'Informe de contingut resolt',
    eus: 'Edukiari buruzko salaketa ebatzi da',
    pt: 'Relatório de conteúdo resolvido'
  },
  [UnsubscribableEmailType.TUTOR_ASSIGNED]: {
    es: 'Asignación de tutor',
    en: 'Tutor assignment',
    cat: 'Assignació de tutor',
    eus: 'Tutorea esleitua',
    pt: 'Tutora atribuída'
  },
  [UnsubscribableEmailType.NEW_EXAM_GROUP_EXAM]: {
    es: 'Nuevo examen en convocatoria',
    en: 'New exam in exam group',
    cat: 'Nou examen a la convocatòria',
    eus: 'Deialdiko azterketa berria',
    pt: 'Novo exame na convocatória'
  },
  NUMBER_OF_EXAMS: {
    es: '¿A cuántos exámenes te has presentado?',
    en: 'How many exams have you taken?',
    cat: "A quants exàmens t'has presentat?",
    eus: 'Zenbat azterketa egin dituzu?',
    pt: 'Quantos exames você já fez?'
  },
  [EOposNumberOfExams.ZERO]: {
    es: 'Ninguno',
    en: 'None',
    cat: 'Cap',
    eus: 'Bat ere ez',
    pt: 'Nenhum'
  },
  [EOposNumberOfExams.ONE]: {
    es: 'Uno',
    en: 'One',
    cat: 'Un',
    eus: 'Bat',
    pt: 'Um'
  },
  [EOposNumberOfExams.TWO]: {
    es: 'Dos',
    en: 'Two',
    cat: 'Dos',
    eus: 'Bi',
    pt: 'Dois'
  },
  [EOposNumberOfExams.THREE]: {
    es: 'Tres',
    en: 'Three',
    cat: 'Tres',
    eus: 'Hiru',
    pt: 'Três'
  },
  [EOposNumberOfExams.MORE_THAN_THREE]: {
    es: 'Más de tres',
    en: 'More than three',
    cat: 'Més de tres',
    eus: 'Hiru baino gehiago',
    pt: 'Mais de três'
  },
  SELECT_NUMBER_OF_EXAMS: {
    es: 'Selecciona el número de exámenes',
    en: 'Select the number of exams',
    cat: "Selecciona el nombre d'exàmens",
    eus: 'Aukeratu azterketa kopurua',
    pt: 'Selecione o número de exames'
  },
  EXAM_GROUP_DATE: {
    es: '¿A qué convocatoria quieres presentarte?',
    en: 'Which exam group do you want to apply for?',
    cat: 'A quina convocatòria et vols presentar?',
    eus: 'Zein deialditara aurkeztu nahi duzu?',
    pt: 'A que convocatória deseja candidatar-se?'
  },
  EXAMS_CERTIFICATES: {
    es: 'Certificados de exámenes',
    en: 'Exams certificates',
    cat: "Certificats d'exàmens",
    eus: 'Azterketa-ziurtagiriak',
    pt: 'Certificados de exames'
  },
  EXAMS_CERTIFICATES_REQUIRED: {
    es: 'Debes subir los certificados de los exámenes',
    en: 'You must upload the certificates of the exams',
    cat: "Has d'enviar els certificats dels exàmens",
    eus: 'Azterketa-ziurtagiriak ekoitzeko',
    pt: 'Você deve enviar os certificados dos exames'
  },
  CHANGE_ACADEMY: {
    es: 'Cambiar academia',
    en: 'Change academy',
    cat: 'Canviar academia',
    eus: 'Academia aldatu',
    pt: 'Mudar academia'
  },
  DOCUMENTS_TITLE: {
    es: 'Sube aquí tu documentación',
    en: 'Upload your documentation here',
    cat: 'Puja la teva documentació aquí',
    eus: 'Dokumentuak igo',
    pt: 'Carregue sua documentação aqui'
  },
  FROM_HERE_YOU_CAN_UPLOAD_YOUR_DOCUMENTATION: {
    es: 'Desde aquí podrás subir toda la documentación requerida para completar tu matrícula.',
    en: 'From here you can upload all the documentation required to complete your registration.',
    cat: 'Des de aquí pots pujar la documentació requerida per completar la matrícula.',
    eus: 'Ikastarako bete behar dituzten dokumentuak igozko zara',
    pt: 'A partir daqui você pode carregar toda a documentação necessária para completar sua matrícula.'
  },
  STEP_ONE_TITLE: {
    es: 'Sube un único archivo en el formato indicado y en el apartado de documentación correspondiente. ',
    en: 'Upload a single file in the indicated format and in the corresponding documentation section.',
    cat: 'Puja un fitxer en el format indicat i en la secció de documentació corresponent.',
    eus: 'Ikusi fitxategia bat, dokumentuaren atala.',
    pt: 'Carregue um único arquivo no formato indicado e na respectiva secção de documentação.'
  },
  STEP_ONE_DESCRIPTION: {
    es: 'Si tienes más de un archivo que subir, has de unificarlo en un solo documento.',
    en: 'If you have more than one file to upload, combine them into a single document.',
    cat: "Si tens més d'un fitxer per pujar, combina'ls en un sol document.",
    eus: 'Fitxategi bat baino gehiago igo behar badituzu, konbinatu fitxategiak.',
    pt: 'Se você tiver mais de um arquivo para carregar, combine-os em um único documento.'
  },
  STEP_TWO_TITLE: {
    es: 'Revisaremos tu documentación.',
    en: 'We will review your documentation.',
    cat: 'Revisarem la teva documentació.',
    eus: 'Zure dokumentuak aztertuko dizugu.',
    pt: 'Revisaremos sua documentação.'
  },
  STEP_TWO_DESCRIPTION: {
    es: 'Una vez que subas el archivo, nuestro equipo lo revisará y validará lo antes posible.',
    en: 'Once you upload the file, our team will review and validate it as soon as possible.',
    cat: 'Un cop hagis pujat el fitxer, el nostre equip el revisarà i el validarà tan aviat com sigui possible.',
    eus: 'Fitxategia igo ondoren, gure taldea ahalik eta azkarren berrikusiko eta balioztatuko du.',
    pt: 'Assim que carregar o ficheiro, a nossa equipa irá revê‑lo e validá‑lo o mais rapidamente possível.'
  },
  STEP_THREE_TITLE: {
    es: 'Si no cumple los requisitos, te avisaremos.',
    en: 'If it does not meet the requirements, we will notify you.',
    cat: 'Si no compleix els requisits, us notificarem.',
    eus: 'Ez badu betetzen eskakizunak, jakinaraziko dizugu.',
    pt: 'Se não cumprir os requisitos, nós avisaremos.'
  },
  STEP_THREE_DESCRIPTION: {
    es: 'En caso de que el documento no sea aprobado, podrás volver a subir la documentación corregida desde este mismo menú.',
    en: 'In case the document is not approved, you can upload the corrected documentation from this same menu.',
    cat: "En cas que el document no sigui aprovat, pots pujar la documentació corregida des d'aquest mateix menú.",
    eus: 'Dokumentua ezin bada onartu, zure dokumentu berriak igozko zara dokumentuaren atala.',
    pt: 'Em caso de o documento não ser aprovado, você pode carregar a documentação corrigida a partir deste mesmo menu.'
  },
  DNI_FILE_REQUIREMENTS: {
    es: '<strong>DNI/NIE/NIF:</strong> Debes subir en un solo archivo, incluyendo en la misma página la copia de las dos caras: anverso y reverso.',
    en: '<strong>DNI/NIE/NIF:</strong> You must upload in a single file, including on the same page the copy of the two faces: front and back.',
    cat: "<strong>DNI/NIE/NIF:</strong> Has d'enviar en un sol fitxer, inclòs en la mateixa pàgina la còpia de les dues cares: davant iDarrere.",
    eus: '<strong>DNI/NIE/NIF:</strong> Fitxategi bakarra ekoitzeko, fitxa batera bi aurreko eta atzeko irudiak.',
    pt: '<strong>DNI/NIE/NIF:</strong> Deve carregar em um único arquivo, incluindo na mesma página a cópia das duas faces: frente e Darrere.'
  },
  PASSPORT_FILE_DESC: {
    es: '<strong>Pasaporte:</strong> Sube la primera página completa de tu pasaporte.',
    en: '<strong>Passport:</strong> Upload the first complete page of your passport.',
    cat: '<strong>Passaport:</strong> Puja la primera pàgina completa del teu passaport.',
    eus: '<strong>Pasaportea:</strong> Pasaportuaren lehen fitxa osoa ekoitzeko.',
    pt: '<strong>Passaporte:</strong> Carregue a primeira página completa do seu pasaporte.'
  },
  PORTRAIT_FILE_REQUIREMENTS: {
    es: 'Sube una foto tipo carnet con fondo claro y el rostro centrado, mirando al frente. Para que se vea correctamente, se recomienda un tamaño de 160 x 200 píxeles.',
    en: 'Upload a photo type card with clear background and the face centered, looking forward. For it to be seen correctly, it is recommended a size of 160 x 200 pixels.',
    cat: 'PPuja una foto tipus carnet amb fons clar i el rostre centrat, mirant al davant. Perquè es vegi correctament, es recomana una mida de 160 × 200 píxels..',
    eus: 'Karte-irudia ekoitzeko irudia, argi-fondo, fitxa batera bi aurreko eta atzeko irudiak. 160 x 200 pixel tamainua gomendatzen da.',
    pt: 'Carregue uma foto tipo cartão com fundo claro e o rosto centrado, olhando para frente. Para que se veja corretamente, é recomendado um tamanho de 160 x 200 pixels.'
  },
  PORTRAIT_FILE_FORMAT_INFO: {
    es: 'La imagen debe estar en formato JPG o GIF.',
    en: 'The image must be in JPG or GIF format.',
    cat: "L'imatge ha de ser en format JPG o GIF.",
    eus: 'Irudia JPG edo GIF formatuan egon behar da.',
    pt: 'A imagem deve estar em formato JPG ou GIF.'
  },

  SIGNATURES_TO_VALIDATE_FILE_DESC: {
    es: 'En caso de tener asignaturas para convalidar, sube el archivo que te hemos enviado por correo.',
    en: 'If you have subjects to validate, upload the file we have sent you by email.',
    cat: "Si tens assignatures per convalidar, puja el fitxer que t'hem enviat per correu electrònic.",
    eus: 'Gaiak konvalidatu nahi dituzten gaiak ekoitzeko, zure e-posta bidez bidali dizugun fitxategia igozko zara.',
    pt: 'Se você tem disciplinas para convalidar, carregue o arquivo que nós lhe enviamos por e-mail.'
  }
};
